import { PolicyStatus } from '../../console/_statics/policy.statics';

export const hasPolicyExpired = (status: string | undefined) => {
  return status === PolicyStatus.EXPIRED_STATUS;
};

export const isPolicyInForce = (status: string | undefined) => {
  return status === PolicyStatus.IN_FORCE_STATUS;
};
